<div class="k-overlay" *ngIf="isOpened"></div>
<kendo-dialog *ngIf="isOpened" [minWidth]="450" [minHeight]="400" [title]="title" (close)="close()">
    <form class="k-form" #form="ngForm" (ngSubmit)="save()">
        <kendo-gridlayout [gap]="{ rows: 10, cols: 5 }">
            <kendo-gridlayout-item [col]="1" [row]="1">
                <div class="signature-wrapper">
                    <kendo-signature
                        #signature
                        [(value)]="encodedFile"
                        [strokeWidth]="2"
                        [maximizable]="false"
                        [hideLine]="true"></kendo-signature>
                </div>
            </kendo-gridlayout-item>

            <kendo-gridlayout-item [col]="1" [row]="2" *ngIf="form.touched && !encodedFile">
                <div class="label-error">
                    {{ 'cf-signature.dialog.signOnGlassRequired' | translate }}
                </div>
            </kendo-gridlayout-item>
        </kendo-gridlayout>

        <div class="k-actions k-actions-end">
            <button kendoButton type="submit" themeColor="success">
                <i class="fas fa-save"></i>
                {{ 'labels.sign' | translate }}
            </button>
            <button kendoButton type="button" icon="close" themeColor="dark" (click)="close()">
                {{ 'labels.cancel' | translate }}
            </button>
        </div>
    </form>
</kendo-dialog>
